import React from "react";
import { useHistory } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import MetaTags from "react-meta-tags";

//Import Images
import error from "../../assets/images/error-img.png";

const Pages404 = () => {
   return (
    <React.Fragment>
      <div className='account-pages my-5 pt-5'>
        <MetaTags>
          <title>home</title>
        </MetaTags>
        <Container>
          <Row className='justify-content-center'>
            <Col md='8' xl='6'>
              <div>
                <img src={error} alt='' className='img-fluid' />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Pages404;
